import { concatStyleSets, Stack, useTheme } from "@fluentui/react";
import React from "react";
import { Button } from "../generic/Button/Button";
import { getWideDefaultButtonStyle } from "../generic/Button/Button.styles";
import { Text } from "../generic/Text/Text";
import { getContainerStyle } from "./ErrorComponent.styles";
export const ErrorComponent = ({ reloadClick, styles, mainText, subtext, buttonText }) => {
    const theme = useTheme();
    return (React.createElement(Stack, { horizontalAlign: "center", verticalAlign: "center", styles: concatStyleSets(getContainerStyle(theme), styles) },
        React.createElement(Text, { variant: "mediumPlus", marginBottom: "12px" }, mainText),
        React.createElement(Text, { variant: "medium", marginBottom: "12px" }, subtext),
        React.createElement(Button, { primary: true, onClick: () => reloadClick(), styles: getWideDefaultButtonStyle() }, buttonText)));
};
